import { FC } from 'react'
import { observer } from 'mobx-react'
import { IPublicUser } from '@/types'
import { reactStringReplace, sanitizeUrl } from '@/utils'
import { URL_PATTERN } from '@/constants'
import styles from './index.module.scss'

type Props = {
  user: IPublicUser
}

export const UserDetailHeaderBio: FC<Props> = observer(({ user }) => {
  return (
    <p className={styles.text}>
      {reactStringReplace(user?.profile.bio, URL_PATTERN, (match, i) => (
        <a key={i} href={sanitizeUrl(match)} target='_blank' rel='noreferrer'>
          {match}
        </a>
      ))}
    </p>
  )
})
